import { extractTextFromQuery } from '../../../utils/query';
import { creator_firstName_$ilike_includes, creator_lastName_$ilike_includes } from '../../../utils/query-helpers';

export default {
  param: extractTextFromQuery,
  query: function (text) {
    const words = text.trim().split(' ');

    if (text) {
      return {
        $or: words.map(function(word){
          return {
            event: {
              $where: {
                ...creator_firstName_$ilike_includes(word)
              }
            }
          };
        }).concat(words.map(function(word){
          return {
            event: {
              $where: {
                ...creator_lastName_$ilike_includes(word)
              }
            }
          };
        }))
      }
    }
  }
}
